import './App.css';
import HomePage from './pages/HomePage';
import PeoplePage from './pages/PeoplePage';
import PublicationPage from './pages/PublicationPage';
import FacilityPage from './pages/FacilityPage';
import FacilitiesPage from './pages/FacilitiesPage';
import ContactPage from './pages/ContactPage';
import ResearchPage from './pages/ResearchPage';
import NavBar from './NavBar';
import { Link } from 'react-router-dom';
import Footer from './components/Footer';

import 'bootstrap/dist/css/bootstrap.min.css';

import {
  HashRouter as Router,
  Route,
} from 'react-router-dom';
import NewsPage from './pages/NewsPage';

function App() {
  return (
    <>
    <div classsName="page-container">
    <div className="contentWrap">
    <div className="topHeader" style={{backgroundColor: 'black'}}> 
      {/* <Nav.Link as={Link} to="/">Functional Material Studio</Nav.Link> */}
      <div style={{display: 'flex', marginLeft: '13%', width:'100%', height: '100%'}}>
        <img src="logo-left.png" width="auto" height="80%" alt="not found" style={{marginRight: '2%', marginTop: '20px', display:'inline-block'}}/>
        <div style={{ display: 'inline', width: '50%', marginRight: '2%'}}>
          <a as={Link} to="/" className="siteTitle" style={{width: '100%', textDecoration: 'underline', textDecorationColor: '#EBC132', textUnderlineOffset: 12}}>Functional Material Studio</a>
          <a style={{color: '#fff', fontSize: '1.75rem', fontWeight: 800}}>Discovery and Innovation since 2018</a>
        </div>
        <div style={{display: 'inline', paddingLeft: '10%'}}>
          <img src="logo-right.png" width="160" height="125" alt="not found" style={{marginTop: '15px', display:'inline-block'}}/>
        </div>
      </div>
    </div>
    <Router>
      <div className="App">
        <NavBar />
        <div id="page-body" className="container-fluid">
          <Route path="/" component={HomePage} exact />
          <Route path="/people" component={PeoplePage}/>
          <Route path="/publications" component={PublicationPage}/>
          <Route path="/facilities" component={FacilitiesPage}/>
          <Route path="/facility/:name" component={FacilityPage}/>
          <Route path="/contact" component={ContactPage}/>
          <Route path="/research/:name" component={ResearchPage}/>
          <Route path="/news" component={NewsPage}/>
        </div>
      </div>
    </Router>
    </div>
    {/* <Footer /> */}
    </div>
    </>
  );
}

export default App;
